import React from 'react';
import { Code, ArrowRight, Palette, Coins } from 'lucide-react';

const Hero = () => {
  return (
    <div className="text-center mb-12">
      <h1 className="text-4xl font-bold text-gray-900 mb-4">
        Monetize Your Website with AdSpotter
      </h1>
      <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-12">
        A lightweight, customizable widget that helps you receive and manage ad space offers directly on your website.
      </p>

      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-md p-8">
        <div className="flex items-center gap-2 mb-8">
          <Code className="w-6 h-6 text-indigo-600" />
          <h2 className="text-xl font-semibold">How It Works</h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="flex flex-col items-center text-center">
            <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center mb-4">
              <Code className="w-6 h-6 text-indigo-600" />
            </div>
            <h3 className="text-lg font-semibold mb-2">1. Add the Widget</h3>
            <p className="text-gray-600">
              Simply add our widget script to your website's HTML to get started
            </p>
          </div>

          <div className="flex flex-col items-center text-center">
            <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center mb-4">
              <Palette className="w-6 h-6 text-indigo-600" />
            </div>
            <h3 className="text-lg font-semibold mb-2">2. Customize</h3>
            <p className="text-gray-600">
              Personalize the widget's appearance to match your website's design
            </p>
          </div>

          <div className="flex flex-col items-center text-center">
            <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center mb-4">
              <Coins className="w-6 h-6 text-indigo-600" />
            </div>
            <h3 className="text-lg font-semibold mb-2">3. Start Earning</h3>
            <p className="text-gray-600">
              Receive and manage advertising offers directly through your dashboard
            </p>
          </div>
        </div>

        <div className="mt-8 flex justify-center">
          <button className="flex items-center gap-2 bg-indigo-600 text-white px-6 py-3 rounded-lg hover:bg-indigo-700 transition-colors">
            Get Started Now
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Hero;